module.exports = __webpack_public_path__ + "static/media/SimplonNorm.43be51d3.woff2";